import { SlideFrame, Reveal } from "@/components/presentation/slides/SlideFrame";
import { MediaPlaceholder } from "@/components/primitives/MediaPlaceholder";

/**
 * 08 · QuoteSlide
 *
 * A large quotation as the protagonist. Attribution + a small portrait
 * placeholder beneath, with optional supporting commentary off to the side.
 */
export const QuoteSlide = ({
  eyebrow = "Voice",
  quote = "A single sentence that does the work of an entire paragraph.",
  attribution = "Attribution",
  role = "Role · Placeholder",
  commentary,
}) => {
  return (
    <SlideFrame testId="slide-quote" width="narrow">
      <Reveal delay={0}>
        <span className="haevn-eyebrow">{eyebrow}</span>
      </Reveal>
      <Reveal delay={1}>
        <blockquote
          data-testid="quote-body"
          className="text-balance text-3xl font-medium leading-snug tracking-tight text-foreground sm:text-4xl md:text-5xl"
        >
          &ldquo;{quote}&rdquo;
        </blockquote>
      </Reveal>
      <div className="grid grid-cols-1 items-center gap-8 sm:grid-cols-12 sm:gap-10">
        <Reveal delay={2} className="sm:col-span-3">
          <MediaPlaceholder
            kind="image"
            label="Portrait"
            ratio="1/1"
            testId="quote-portrait"
            className="mx-auto max-w-[120px]"
          />
        </Reveal>
        <div className="flex flex-col gap-1 sm:col-span-5" data-testid="quote-attribution">
          <Reveal delay={3}>
            <div className="text-sm font-medium text-foreground">{attribution}</div>
          </Reveal>
          <Reveal delay={4}>
            <div className="text-sm text-muted-foreground">{role}</div>
          </Reveal>
        </div>
        {commentary && (
          <Reveal delay={5} className="sm:col-span-4">
            <p
              data-testid="quote-commentary"
              className="border-l border-border pl-5 text-sm leading-relaxed text-muted-foreground"
            >
              {commentary}
            </p>
          </Reveal>
        )}
      </div>
    </SlideFrame>
  );
};

export default QuoteSlide;
